<template>
<v-layout row wrap>
    <v-flex xs12 lg6>
        <v-card class="elevation-3 dash-card">
            <v-toolbar class="q-orange-bk q-text-whitesmoke elevation-1" style="height:50px;">
                <v-toolbar-title style="padding-bottom:15px">
                    <h3>{{getString('Rinnova la tua sottoscrizione')}}</h3>
                </v-toolbar-title>
            </v-toolbar>
            <v-card-text>
                <div>
                    <h2>{{getString('Per effettuare il rinnovo contattaci cliccando sul tasto supporto in basso a destra.')}}</h2>
                  <!--  <h3>{{getString('Genera le coordinate di pagamento')}}</h3>
                    <v-radio-group v-model="radioGroup" row>
                        <v-radio :label="getString('Mensile - {0}€ + iva', [response.montlyPrice.toFixed(2)])" :value="0"></v-radio>
                        <v-radio :label="getString('Semestrale - {0}€ + iva', [response.sixMontlyPrice.toFixed(2)])" :value="1"></v-radio>
                        <v-radio :label="getString('Annuale - {0}€ + iva', [response.yearlyPrice.toFixed(2)])" :value="2"></v-radio>
                    </v-radio-group>
                    <div class="paymentInfoContainer">
                        <div>{{getString('INTESTATARIO: ')}}<b>{{response.bankIntestate}}</b></div>
                        <div>{{getString('CODICE IBAN: ')}}<b>{{response.iban}}</b></div>
                        <div>{{getString('IMPORTO: ')}}<b>{{timePrice[radioGroup]}}</b></div>
                        <div v-html="getString('CAUSALE: PAGAMENTO SOTTOSCRIZIONE <b>{0}</b> DI QUICKBE PER <b>{1}</b>', [timeRange[radioGroup],response.userName])"></div>
                    </div> -->
                </div>
            </v-card-text>
        </v-card>
    </v-flex>
    <v-flex xs12 lg6>
        <a ref="downloadLink" v-show="false"></a>
        <v-card class="elevation-3 dash-card">
            <v-toolbar class="q-orange-bk q-text-whitesmoke elevation-1" style="height:50px;">
                <v-toolbar-title style="padding-bottom:15px">
                    <h3>{{getString('Gestione fatture')}}</h3>
                </v-toolbar-title>
            </v-toolbar>
        </v-card>
        <v-card-text>
            <v-data-table :no-data-text="getString('Nessuna fattura ancora disponibile')" :loading="loading" :headers="table_headers" :items="response.payments" hide-actions class="elevation-1">
                <template slot="items" slot-scope="props">
                    <tr>
                        <td>{{ getFormattedDate(props.item.date) }}</td>
                        <td>{{ props.item.priceText }}</td>
                        <td v-if="props.item.pathInvoice !== ''">
                            <v-btn class="q-orange-bk q-text-whitesmoke" @click="downloadFattura(props.item.pathInvoice)">Scarica</v-btn>
                        </td>
                        <td v-if="props.item.pathInvoice === ''">{{getString('La fattura non è ancora disponibile, riprova più tardi')}}</td>
                    </tr>
                </template>
            </v-data-table>
        </v-card-text>
    </v-flex>

</v-layout>
</template>

<script>
import ajax from '../../ajax.js'
import Moment from 'moment'
export default {
    name: 'Payments',
    mounted: function () {
        
        this.getFatture()
    },
    data: () => {
        return {
            table_headers: [
                {
                    text: 'Data',
                    align: 'left',
                    sortable: true,
                    value: 'date'
                },
                {
                    text: 'Costo',
                    align: 'left',
                    sortable: false,
                    value: 'price'
                },
                {
                    text: 'Fattura',
                    align: 'left',
                    sortable: false,
                    value: 'pathInvoice'
                }
            ],
            response: {
                montlyPrice: 0,
                sixMontlyPrice: 0,
                yearlyPrice: 0,
                payments: [],
                userName: ''
            },
            timeRange: ['MENSILE', 'SEMESTRALE', 'ANNUALE'],
            radioGroup: 0,
            loading: false,
            baseUrl: ajax.baseUrl()
        }
    },
    computed: {
        timePrice: function () {
            return [
                this.addIva(this.response.montlyPrice) + '€',
                this.addIva(this.response.sixMontlyPrice) + '€',
                this.addIva(this.response.yearlyPrice) + '€'
            ]
        }
    },
    methods: {
        addIva: function (money) {
            return (parseFloat(money) + money * 0.22).toFixed(2)
        },
        getFatture: function () {
            let self = this
            this.loading = true
            ajax.axios
                .get(ajax.baseUrl() + '/admin/payments/fatture', {
                    headers: self.$store.getters.tokenHeader,
                    withCredentials: true
                })
                .then(function (response) {
                    ajax.validateToken(response.headers,self.$store)
                    self.response = response.data.data
                    self.loading = false
                })
                .catch(function (error) {
                    self.loading = false
                    var auth = ajax.checkAuth(error, self.$store, self.$router)
                    self.$emit(
                        'siteAlert',
                        auth ?
                        self.getString("Non hai l'autorizzazione") :
                        error.response.data.errorMessage
                    )
                })
        },
        downloadFattura: function (filename) {
            let self = this
            ajax.axios
                .get(ajax.baseUrl() + '/admin/payments/download/' + filename, {
                    headers: self.$store.getters.tokenHeader,
                    withCredentials: true,
                    responseType: 'arraybuffer'
                })
                .then(response => {
                    ajax.validateToken(response.headers,self.$store)
                    const url = window.URL.createObjectURL(new Blob([response.data]))
                    const link = this.$refs.downloadLink
                    link.href = url
                    link.setAttribute('download', 'file.pdf')
                    document.body.appendChild(link)
                    link.click()
                })
                .catch(function (error) {
                    self.loading = false
                    var auth = ajax.checkAuth(error, self.$store, self.$router)
                    self.$emit(
                        'siteAlert',
                        auth ?
                        self.getString("Non hai l'autorizzazione") :
                        error.response.data.errorMessage
                    )
                })
        },
        getString: function (key, values) {
            return this.$store.state.currentTranslator.getString(key, values)
        },
        getFormattedDate: function(date) {
            return new Moment(date).format("DD/MM/YYYY")
        }
    }
}
</script>

<style scoped>
.paymentInfoContainer {
    background-color: white;
    border: 3px solid rgb(110, 158, 171);
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/Payments.vue